export const SIGN_IN = '/signIn';
export const SIGN_IN_WITH_EMAIL = `${SIGN_IN}/email`;
export const SIGN_UP = '/signUp';
export const PROFILE = '/profile';
export const ACCOUNT = 'account';
export const ADDRESSES = 'addresses';
export const ORDERS = 'orders';
export const ORDER_VIEW = 'orders/:parcelNumber';

export const HOME = '/';
export const PICKUP_FINDER = '/pickup-finder';
export const RETURN = '/return';
export const TRACK = '/track';
export const TRACK_PARCEL_DETAILS = '/track/:parcelCode';
export const ORDER = '/order';
export const QUOTES = '/quotes';
export const SHIPMENT = '/shipments/:shipmentId';
export const ORDER_SUMMARY = '/orders/:orderId';
export const NOT_FOUND = '/404-not-found';
export const DONT_HAVE_ACCESS = '/dont-have-access';
export const BASKET = '/basket';
export const EMAIL = 'email';
export const MAP_SAND_BOX = 'mapsandbox';
export const HELP = '/help';
export const FAQ = '/FAQ';
export const PRODUCTS_AND_SERVICES =
  '/products-and-services/:service?/:country?';

export const EXPIRED_LABEL = '/expiredLabel';

export const DEV = 'dev';
export const DEV_PLAYGROUND = '/dev/playground';

export const SHIPPING_TO_USA = '/shipping-to-usa';

// CitySprint same-day routes
export const SEND_A_CITYSPRINT_PARCEL = '/send-citysprint-parcel';
export const SEND_A_CITYSPRINT_PARCEL_SUMMARY =
  '/send-citysprint-parcel/summary';
export const SEND_A_CITYSPRINT_PARCEL_COMPLETE_BOOKING =
  '/send-citysprint-parcel/complete-booking';
export const SEND_A_CITYSPRINT_PARCEL_REVIEW_BOOK =
  '/send-citysprint-parcel/review-book';
export const CITYSPRINT_BOOKING_CONFIRMATION = '/citysprint/:bookingId';
